var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2499 37.5C75.2499 16.7895 58.4604 0 37.7499 0C30.414 0 23.5711 2.10864 17.7911 5.74966L26.0108 9.24199L14.9238 13.9526L26.0108 18.6631L14.9238 23.3735L26.0108 28.0837L14.9238 32.7933L26.0108 37.5026L14.9238 42.213L26.0108 46.923L14.9238 51.6327L26.0108 56.3427L14.9238 61.0531L26.0108 65.7627L17.7948 69.2531C23.574 72.8924 30.4154 75 37.7499 75C58.4604 75 75.2499 58.2105 75.2499 37.5Z",
    fill: "#751A46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagQatar);
export default __webpack_public_path__ + "static/media/flagQatar.a804a87d8f73a012551c52956e186876.svg";
export { ForwardRef as ReactComponent };